/*
  Home Hero: USP-Darstellung "Wort-Wechsel" (usp_display = rotate).
  Nur geladen, wenn die Section auf "rotate" steht (defer).

  - Die Spur (.home-hero__rot-track) rollt per translateY(-i * 1.1em) nach oben.
    Nahtlose Schleife: das erste Item wird ans Ende geklont; nach dem Rollen auf
    den Klon springt die Spur ohne Transition zurueck auf 0.
  - Standzeit und Roll-Dauer aus den Section-Settings (Default 3 s / 0,5 s),
    der aktive Strich fuellt sich in der Standzeit (CSS, --rot-dwell).
  - prefers-reduced-motion: kein Rollen, Opacity-Wechsel per .is-active (CSS).
  - Pausiert, wenn die Besucherin das Hero-Video pausiert (.gv-toggle aus
    snippets/global-video.liquid), wenn der Hero aus dem Bild ist, der Tab
    verborgen ist oder im Theme-Editor ein Pill-Block ausgewaehlt ist.
  - Beliebig viele Items; 1 Item = statisch (kein Timer).
*/
(function () {
  'use strict';

  // Script-Tag steht je Section-Instanz im Markup: nur einmal ausfuehren.
  if (window.HeroUspRotate) return;
  window.HeroUspRotate = { init: function (scope) { init(scope); } };

  // Fallbacks; pro Instanz ueberschrieben aus data-rot-dwell / data-rot-roll (ms,
  // Section-Settings usp_rotate_dwell / usp_rotate_roll). Muessen zu den
  // CSS-Variablen --rot-dwell / --rot-roll am selben Element passen.
  var DWELL = 3000;
  var ROLL = 500;

  function msAttr(el, name, fallback) {
    var v = parseFloat(el.getAttribute(name));
    return isFinite(v) && v > 0 ? v : fallback;
  }
  var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reduced() {
    return !!(reduceMQ && reduceMQ.matches);
  }

  function isShown(el) {
    return !!el && el.getClientRects().length > 0;
  }

  function Rot(root) {
    this.root = root;
    this.section = root.closest('.home-hero') || document;
    this.frame = root.closest('.home-hero__frame') || this.section;
    this.track = root.querySelector('.home-hero__rot-track');
    this.items = this.track ? [].slice.call(this.track.querySelectorAll('.home-hero__rot-item')) : [];
    this.dashes = [].slice.call(root.querySelectorAll('.home-hero__rot-dash'));
    this.n = this.items.length;
    this.dwell = msAttr(root, 'data-rot-dwell', DWELL);
    this.roll = msAttr(root, 'data-rot-roll', ROLL);
    this.i = 0;
    this.phase = 'dwell';
    this.remaining = this.dwell;
    this.stepStart = 0;
    this.timer = null;
    this.rollTimer = null;
    this.toggleUsed = false;
    this.editorHold = false;
    this.offscreen = false;
    this.listeners = [];

    root._heroRot = this;
    if (this.n < 2) {
      root.classList.add('is-ready');
      return;
    }

    var clone = this.items[0].cloneNode(true);
    clone.removeAttribute('data-shopify-editor-block');
    clone.classList.remove('is-active');
    clone.classList.add('is-clone');
    this.track.appendChild(clone);

    this.bind();
    this.setY(0, false);
    this.setItem(0);
    root.classList.add('is-ready');
    this.startDwell();
  }

  Rot.prototype.on = function (target, type, fn, opts) {
    target.addEventListener(type, fn, opts || false);
    this.listeners.push([target, type, fn, opts || false]);
  };

  Rot.prototype.bind = function () {
    var self = this;
    var sync = function () { self.update(); };

    // Pause-Knopf des Hero-Videos: Capture-Phase, weil der Knopf stopPropagation ruft.
    this.on(this.frame, 'click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.gv-toggle')) {
        self.toggleUsed = true;
        setTimeout(sync, 0);
      }
    }, true);

    [].slice.call(this.section.querySelectorAll('.home-hero__media video')).forEach(function (v) {
      self.on(v, 'pause', sync);
      self.on(v, 'play', sync);
    });

    this.on(document, 'visibilitychange', sync);

    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { self.offscreen = !entry.isIntersecting; });
        self.update();
      });
      this.io.observe(this.root);
    }

    if (reduceMQ) {
      var onMQ = function () { self.setY(reduced() ? 0 : self.i, false); };
      if (reduceMQ.addEventListener) {
        reduceMQ.addEventListener('change', onMQ);
        this.listeners.push([reduceMQ, 'change', onMQ, false]);
      }
    }
  };

  Rot.prototype.heroVideo = function () {
    var vids = this.section.querySelectorAll('.home-hero__media video');
    for (var k = 0; k < vids.length; k++) {
      if (isShown(vids[k])) return vids[k];
    }
    return null;
  };

  Rot.prototype.videoPaused = function () {
    var v = this.heroVideo();
    if (!v || !v.paused) return false;
    if (v._gvUserPaused === true) return true;
    var t = this.frame.querySelector('.gv-toggle');
    return !!(this.toggleUsed && t && t.classList.contains('is-paused'));
  };

  Rot.prototype.isPaused = function () {
    return this.editorHold || this.offscreen || document.hidden || this.videoPaused();
  };

  Rot.prototype.setY = function (k, animate) {
    if (!this.track) return;
    if (!animate) this.track.style.transition = 'none';
    this.track.style.transform = reduced() ? '' : 'translate3d(0,' + (-1.1 * k) + 'em,0)';
    if (!animate) {
      void this.track.offsetHeight;
      this.track.style.transition = '';
    }
  };

  Rot.prototype.setItem = function (idx) {
    this.items.forEach(function (el, k) { el.classList.toggle('is-active', k === idx); });
  };

  Rot.prototype.setDash = function (idx) {
    this.dashes.forEach(function (d) { d.classList.remove('is-active'); });
    var d = this.dashes[idx];
    if (d) {
      void d.offsetWidth; // Fuell-Animation neu starten
      d.classList.add('is-active');
    }
  };

  Rot.prototype.startDwell = function () {
    this.phase = 'dwell';
    this.remaining = this.dwell;
    this.timer = null;
    this.setDash(this.i);
    this.update();
  };

  Rot.prototype.update = function () {
    var paused = this.isPaused();
    this.root.classList.toggle('is-paused', paused);
    if (this.phase !== 'dwell') return;
    if (paused) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        this.remaining = Math.max(0, this.remaining - (Date.now() - this.stepStart));
      }
    } else if (!this.timer) {
      var self = this;
      this.stepStart = Date.now();
      this.timer = setTimeout(function () { self.advance(); }, this.remaining);
    }
  };

  Rot.prototype.advance = function () {
    var self = this;
    this.timer = null;
    this.phase = 'roll';
    var next = this.i + 1;
    var idx = next % this.n;
    this.setItem(idx);
    if (reduced()) {
      this.rollTimer = setTimeout(function () {
        self.rollTimer = null;
        self.i = idx;
        self.startDwell();
      }, this.roll);
      return;
    }
    this.setY(next, true);
    this.rollTimer = setTimeout(function () {
      self.rollTimer = null;
      if (next >= self.n) self.setY(0, false);
      self.i = idx;
      self.startDwell();
    }, this.roll + 40);
  };

  // Theme-Editor: zu einem Item springen und anhalten
  Rot.prototype.goTo = function (idx, hold) {
    clearTimeout(this.timer);
    clearTimeout(this.rollTimer);
    this.timer = null;
    this.rollTimer = null;
    this.editorHold = !!hold;
    this.i = idx;
    this.setY(idx, false);
    this.setItem(idx);
    this.startDwell();
  };

  Rot.prototype.destroy = function () {
    clearTimeout(this.timer);
    clearTimeout(this.rollTimer);
    if (this.io) this.io.disconnect();
    this.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    this.listeners = [];
    // Zurueck auf den Ausgangszustand, damit ein erneutes init sauber startet
    if (this.track) {
      [].slice.call(this.track.querySelectorAll('.is-clone')).forEach(function (c) { c.remove(); });
      this.track.style.transition = '';
      this.track.style.transform = '';
    }
    this.dashes.forEach(function (d) { d.classList.remove('is-active'); });
    this.items.forEach(function (el, k) { el.classList.toggle('is-active', k === 0); });
    this.root.classList.remove('is-ready', 'is-paused');
    this.root._heroRot = null;
  };

  function init(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-hero-rot]')).forEach(function (root) {
      if (!root._heroRot) new Rot(root);
    });
  }

  function rotFor(target) {
    var root = target && target.closest ? target.closest('[data-hero-rot]') : null;
    return root && root._heroRot ? root._heroRot : null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].slice.call(e.target.querySelectorAll('[data-hero-rot]')).forEach(function (root) {
      if (root._heroRot) root._heroRot.destroy();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var rot = rotFor(e.target);
    if (!rot || rot.n < 2) return;
    var idx = rot.items.indexOf(e.target);
    if (idx > -1) rot.goTo(idx, true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var rot = rotFor(e.target);
    if (!rot || rot.n < 2) return;
    rot.editorHold = false;
    rot.update();
  });
})();
